import { render, staticRenderFns } from "./Rembug.vue?vue&type=template&id=920c82bc"
import script from "./Rembug.vue?vue&type=script&lang=js"
export * from "./Rembug.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports